/* eslint-disable */
import React, { useState } from 'react'
import Autosuggest from 'react-autosuggest'
import { handleChange } from 'lib/stores/formStore'
import { formatIdFromName } from 'lib/utility'

import FormLabel from './FormLabel'

const FormSearchField = ({
  name, id, label, options, required = true, useLocale = true
}) => {
  const [value, setValue] = useState('')
  const [suggestions, setSugesstions] = useState([])
  const inputProps = {
    placeholder: 'Search...',
    value,
    id,
    name,
    onChange: (event, { newValue }) => setValue(newValue)
  }

  const getSuggestions = value => {
    const inputValue = value.trim().toLowerCase()
    const inputLength = inputValue.length

    return inputLength === 0 ? [] : options.filter(option => option.name.toLowerCase().slice(0, inputLength) === inputValue)
  }

  const getSuggestionValue = suggestion => suggestion.name

  const renderSuggestion = (suggestion, { isHighlighted }) => {
    const classes = ['choices__item choices__item--choice choices__item--selectable']

    if (isHighlighted) classes.push('is-highlighted')

    return (
      <div className={classes.join(' ')}>
        {suggestion.name}
      </div>
    )
  }

  const onSuggestionsFetchRequested = ({ value }) => setSugesstions(getSuggestions(value))

  const onSuggestionsClearRequested = () => setSugesstions([])

  const renderSuggestionsContainer = ({ containerProps, children, query }) => (
    <div className="choices__list choices__list--dropdown" {...containerProps}>
      <div className="choices__list">
        {children}
      </div>
    </div>
  )

  return (
    <div className="mb-3">
      <FormLabel id={id || formatIdFromName(name)} label={label || name} required={required} useLocale={useLocale} />
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        renderSuggestionsContainer={renderSuggestionsContainer}
        inputProps={inputProps}
        theme={{
          input: 'react-autosuggest__input form-control'
        }}
      />
    </div>
  )
}

export default FormSearchField
